import React from "react";
import { useWindTurbineColorBar } from "../CustomHooks";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";

const WindTurbineColorBar = () => {
  const { minValue, maxValue, isVisible } = useWindTurbineColorBar();
  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.WIND_TURBINE}
      category="Wind Turbine"
      subcategory="Zone"
      unit="AEP(kWh)"
      dataMin={minValue}
      dataMax={maxValue}
      isVisible={isVisible}
    />
  );
};

export default WindTurbineColorBar;
